export default __webpack_public_path__ + "static/media/python-logo.7d03065b.png";